export enum QuestionType {
    SEX = 'SEX',
    AGE = 'AGE',
    CLOTHES_SIZES = 'CLOTHES_SIZES',
    SHOES_SIZES = 'SHOES_SIZES',
    PRICES = 'PRICES',
    STYLE = 'STYLE',
    CATEGORIES = 'CATEGORIES',
}
